import { useController } from "react-hook-form";

export interface TextInputStepProps {
	name: string;
	label: string;
	placeholder?: string;
	maxLength?: number;
	textArea?: boolean;
	className?: string;
}

const TextInputStep = ({
	name,
	label,
	placeholder,
	maxLength,
	textArea = false,
	...restProps
}: TextInputStepProps) => {
	const { field } = useController({ name, defaultValue: "" });
	const inputId = `text-input-step-${name}`;

	const sharedProps = {
		id: inputId,
		maxLength,
		placeholder,
		...field,
		className:
			"w-full bg-white border border-border rounded-lg px-3 py-2 text-base text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring transition-colors"
	};

	return (
		<div {...restProps}>
			<label
				htmlFor={inputId}
				className="block text-sm font-medium text-zinc-600 mb-1.5"
			>
				{label}
			</label>

			{textArea ? (
				<textarea {...sharedProps} rows={3} />
			) : (
				<input type="text" {...sharedProps} />
			)}

			{maxLength && (
				<p
					aria-label="character-count"
					className="text-[13px] text-zinc-500 text-right mt-1"
				>
					{field.value ? field.value.length : 0} / {maxLength}
				</p>
			)}
		</div>
	);
};

export default TextInputStep;
